var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIdentifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0606 0.738281H1.94056C1.26361 0.738281 0.714844 1.28705 0.714844 1.964V13.0383C0.714844 13.7152 1.26361 14.264 1.94056 14.264H18.0606C18.7375 14.264 19.2863 13.7152 19.2863 13.0383V1.964C19.2863 1.28705 18.7375 0.738281 18.0606 0.738281Z",
    stroke: "#434C5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3711 5.89844H16.2094",
    stroke: "#434C5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3711 8.71484H16.2094",
    stroke: "#434C5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01172 6.36744C5.01172 7.66199 6.06116 8.71144 7.35572 8.71144C7.68299 8.71144 7.99459 8.64437 8.27753 8.52322C9.1138 8.16515 9.6997 7.33472 9.6997 6.36744C9.6997 5.07288 8.65028 4.02344 7.35572 4.02344C6.06116 4.02344 5.01172 5.07288 5.01172 6.36744Z",
    stroke: "#434C5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79297 11.0347C4.16543 10.3263 4.6889 9.74079 5.31305 9.33452C5.93721 8.92823 6.64107 8.71484 7.35695 8.71484C8.07285 8.71484 8.77671 8.92823 9.40087 9.33452C10.025 9.74079 10.5485 10.3263 10.921 11.0347",
    stroke: "#434C5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIdentifier);
export default __webpack_public_path__ + "static/media/userIdentifier.a14af779b327bd58bcf193459d82284e.svg";
export { ForwardRef as ReactComponent };